import { Component, computed, inject } from '@angular/core';
import { UtilityService } from '../../../../services/util';
import { AngularBaseFieldWidget } from '../angular-base-field-widget';
import { AngularTextField } from '../angular-form-fields';


@Component({
	selector: 'angular-text-field',
	templateUrl: './angular-text-field.widget.html',
})

export class AngularTextFieldWidget extends AngularBaseFieldWidget<AngularTextField> {

	#util = inject(UtilityService);

	readonly inputType = computed(() => {
		const v = this.field().validations;
		if (!v) return 'text';
		if (v.isEmail) return 'email';
		if (v.isURL) return 'url';
		return 'text';
	});

	onInput(event: Event): void {
		const target = event.target as HTMLInputElement | HTMLTextAreaElement;
		let val = target.value;

		const fixCase = this.field().fixCase;
		if (fixCase) {
			val = this.#util.text.fixCase(val, fixCase);
		}

		// If the field has a phone validation, clean the value to a standard format of +1XXXXXXXXXX
		if (this.field().validations?.isPhone) {
			val = val.replace(/\D/g, '');

			// 11 digits starting with 1 (e.g., 15551234567 or +15551234567)
			if (val.length === 11 && val.startsWith('1')) { val = `+1${val.slice(1)}`; }

			// 10 digits starting with 2-9, as US phone numbers start from 2-9 (e.g., 5551234567)
			else if (val.length === 10 && !val.startsWith('1')) { val = `+1${val}`; }

			// Otherwise (1234, 1555123456, etc.), leave target.value unchanged
		}

		this.field().formField().value.set(val);
	}

}